import React, {
    useCallback,
    useMemo,
} from 'react';
import PropTypes from 'prop-types';

import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';
import {
    useReelStore,
    useModalStore,
    useMediaPlayback,
} from 'bdvp-common/src/hooks/store';

import Component from '../components/ClipTrimming';

const { TRIM_REEL_CLIP_MODAL_NAME } = modalConstants;

const ClipTrimming = (props) => {

    const { submitButtonRef } = props;
    const { modalHide } = useModalStore();
    const {
        data,
        updateReelClip,
        trimmingMediaId,
    } = useReelStore();
    const mediaPlayback = useMediaPlayback(trimmingMediaId, true);

    const reelClip = useMemo(() => data?.reel.reelClips.find(clip => clip.mediaId === trimmingMediaId), [
        data,
        trimmingMediaId,
    ]);

    const trimClip = useCallback((id, startTime, endTime, originalDuration) => {

        return updateReelClip(id, startTime, endTime, originalDuration).then(() => modalHide(TRIM_REEL_CLIP_MODAL_NAME));

    }, [
        modalHide,
        updateReelClip,
    ]);

    return (
        <Component
            reelClip={reelClip}
            mediaPlayback={mediaPlayback}
            trimClip={trimClip}
            submitButtonRef={submitButtonRef}
        />
    );

};

ClipTrimming.propTypes = {
    submitButtonRef: PropTypes.object.isRequired,
};

export default ClipTrimming;
